import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {requestJson} from "../apiUtils";

type LoginPayload = {
    username: string;
    password: string;
};

export function useLoginMutation(): UseMutationResult<number, Error, LoginPayload> {
    return useMutation({
        mutationFn: async ({username, password}) => {
            const response = await requestJson<{secondsUntilLogout: number}>("/login", {
                method: "POST",
                body: JSON.stringify({username: username, password: password}),
            });

            return response.secondsUntilLogout;
        },
    });
}
